import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import axiosInstance from '../../../services/AxiosInstance';
import LogoutPage from './Logout';
import EditProfileCorporate from './EditProfileCorporate';
import EditProfileCorporateUser from './EditProfileCorporateUser';
import { useSidebar } from './SidebarContext';
import './sidebarProfile.css';

function getUserDisplayName(userData) {
  if (!userData) return null;
  const name = userData.name || userData.full_name || userData.FullName || '';
  return String(name).trim() || null;
}

function resolveCorporateNameFromUser(u) {
  if (!u) return '';
  const type = (u.type || '').toLowerCase();
  if (type === 'corporate' && u.name) return u.name;
  return (
    u.corporate_name ||
    u.corporateName ||
    u.company_name ||
    u.companyName ||
    u.Corporate?.name ||
    u.corporate?.name ||
    u.organization_name ||
    u.organizationName ||
    ''
  );
}

function getUserInitials(name) {
  if (!name) return '?';
  return name.split(' ').map((n) => n[0]).join('').toUpperCase().slice(0, 2);
}

function getUserEmail(userRaw) {
  if (!userRaw) return '';
  try {
    return JSON.parse(userRaw).email || '';
  } catch {
    return '';
  }
}

function getUserType(userRaw) {
  if (!userRaw) return null;
  try {
    return JSON.parse(userRaw).type;
  } catch {
    return null;
  }
}

export default function SidebarProfile() {
  const { closeSidebar } = useSidebar();
  const [userName, setUserName] = useState(null);
  const [corporateName, setCorporateName] = useState('');
  const userRaw = localStorage.getItem('user');

  useEffect(() => {
    const syncUserName = () => {
      try {
        setUserName(getUserDisplayName(JSON.parse(localStorage.getItem('user') || 'null')));
      } catch {
        setUserName(null);
      }
    };
    syncUserName();
    window.addEventListener('user-logged-in', syncUserName);
    window.addEventListener('storage', syncUserName);
    return () => {
      window.removeEventListener('user-logged-in', syncUserName);
      window.removeEventListener('storage', syncUserName);
    };
  }, []);

  useEffect(() => {
    let cancelled = false;
    const loadCorporateName = async () => {
      try {
        const u = userRaw ? JSON.parse(userRaw) : null;
        const fromUser = resolveCorporateNameFromUser(u);
        if (fromUser) {
          if (!cancelled) setCorporateName(fromUser);
          return;
        }
        const corporateId = u?.corporateId || u?.corporate_id || u?.CorporateId;
        if (!corporateId) {
          if (!cancelled) setCorporateName('');
          return;
        }
        const res = await axiosInstance.get(`/auth/corporate/details/${corporateId}`);
        const name = res?.data?.name || '';
        if (!cancelled) setCorporateName(name);
      } catch {
        if (!cancelled) setCorporateName('');
      }
    };
    loadCorporateName();
    return () => { cancelled = true; };
  }, [userRaw]);

  const handleMenuClick = () => {
    if (window.innerWidth <= 768) {
      closeSidebar();
    }
  };

  const userType = getUserType(userRaw);
  const userEmail = getUserEmail(userRaw);

  return (
    <div className="sidebar-profile">
      <Dropdown drop="up" className="sidebar-profile-dropdown">
        <Dropdown.Toggle
          variant=""
          as="button"
          type="button"
          className="sidebar-profile-toggle"
          aria-label="Account menu"
        >
          <div className="sidebar-profile-avatar" aria-hidden="true">
            {getUserInitials(userName)}
          </div>
          <div className="sidebar-profile-meta">
            <div className="sidebar-profile-name">{userName || 'User'}</div>
            {corporateName ? (
              <div className="sidebar-profile-workspace">{corporateName}</div>
            ) : null}
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu align="end" className="sidebar-profile-menu">
          <div className="sidebar-profile-menu-header">
            <div className="sidebar-profile-menu-name">{userName || 'User'}</div>
            {userEmail ? (
              <div className="sidebar-profile-menu-email">{userEmail}</div>
            ) : null}
          </div>
          {userType === 'corporate' ? (
            <>
              <EditProfileCorporate onEdit={handleMenuClick} />
              <Dropdown.Item as={Link} to="/user-subscription" onClick={handleMenuClick}>
                My Subscription
              </Dropdown.Item>
              <Dropdown.Item as={Link} to="/credits" onClick={handleMenuClick}>
                Credit Wallet
              </Dropdown.Item>
              <Dropdown.Item as={Link} to="/changePassword" onClick={handleMenuClick}>
                Change Password
              </Dropdown.Item>
            </>
          ) : null}
          {userType === 'user' ? (
            <>
              <EditProfileCorporateUser onEdit={handleMenuClick} />
              <Dropdown.Item as={Link} to="/user-subscription" onClick={handleMenuClick}>
                My Subscription
              </Dropdown.Item>
              <Dropdown.Item as={Link} to="/credits" onClick={handleMenuClick}>
                Credit Wallet
              </Dropdown.Item>
              <Dropdown.Item as={Link} to="/changePassword" onClick={handleMenuClick}>
                Change Password
              </Dropdown.Item>
            </>
          ) : null}
          <LogoutPage />
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}
